import { render, staticRenderFns } from "./ExpressInvestMoney.vue?vue&type=template&id=dd91cc90&scoped=true&"
import script from "./ExpressInvestMoney.vue?vue&type=script&lang=js&"
export * from "./ExpressInvestMoney.vue?vue&type=script&lang=js&"
import style0 from "./ExpressInvestMoney.vue?vue&type=style&index=0&id=dd91cc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd91cc90",
  null
  
)

export default component.exports